import styled from "styled-components";

export const SideFilterButtons = styled.div`
  margin-bottom: 1rem;
  display: grid;
  .btn.btn-danger {
    margin-top: 1rem;
  }
`;
